import {
    useEffect,
    useState
} from 'react';

import {
    getAdminPosts,
    deleteAdminPost,
    updateAdminPost,
    getAdminComments
} from '../../../api/adminApi';

import './PostManage.css';

const PostManage = () => {

    // 검색어
    const [keyword, setKeyword] =
        useState('');





    // 현재 페이지
    const [currentPage, setCurrentPage] =
        useState(1);





    // 전체 페이지
    const [totalPages, setTotalPages] =
        useState(1);





    // 게시글 리스트
    const [posts, setPosts] =
        useState<any[]>([]);





    // 수정 모달
    const [editOpen, setEditOpen] =
        useState(false);





    // 수정 게시글
    const [editPostId, setEditPostId] =
        useState<number | null>(null);





    // 수정 내용
    const [editContent, setEditContent] =
        useState('');





    // 게시글 조회
    useEffect(() => {

        fetchPosts();

        // eslint-disable-next-line

    }, [keyword, currentPage]);





    // 게시글 가져오기
    const fetchPosts = async () => {

        try {

            const response =
                await getAdminPosts(

                    currentPage,

                    keyword
                );





            setPosts(
                response.data.content
            );





            setTotalPages(
                response.data.totalPages
            );

        } catch (e) {

            console.error(e);
        }
    };





    // 게시글 삭제
    const handleDeletePost = async (
        id: number
    ) => {

        try {

            if(
                !window.confirm(
                    '게시글을 삭제하시겠습니까?'
                )
            ) {

                return;
            }





            await deleteAdminPost(id);





            fetchPosts();

        } catch (e) {

            console.error(e);
        }
    };





    // 수정 모달 열기
    const openEditModal = (
        post: any
    ) => {

        setEditPostId(post.id);

        setEditContent(post.content);

        setEditOpen(true);
    };





    // 게시글 수정
    const handleUpdatePost = async () => {

        try {

            if(!editPostId) {

                return;
            }





            await updateAdminPost(

                editPostId,

                editContent
            );





            alert('수정 완료');





            setEditOpen(false);





            fetchPosts();

        } catch (e) {

            console.error(e);
        }
    };





    // 댓글 보기
    const openComments = async (
        post: any
    ) => {

        try {

            const response =
                await getAdminComments(
                    post.id
                );





            alert(

                `댓글 ${response.data.length}개`
            );

        } catch (e) {

            console.error(e);
        }
    };





    // 페이지 그룹
    const pageGroup =
        Math.floor(
            (currentPage - 1) / 10
        );





    // 시작 페이지
    const startPage =
        pageGroup * 10 + 1;





    // 끝 페이지
    const endPage =
        Math.min(
            startPage + 9,
            totalPages
        );





    // 페이지 배열
    const pageNumbers =
        Array.from(

            {
                length:
                    endPage - startPage + 1
            },

            (_, i) =>
                startPage + i
        );





    return (

        <div className="post-manage">

            {/* 검색 */}
            <div className="post-search-wrap">

                <input

                    type="text"

                    placeholder="게시글 검색"

                    value={keyword}

                    onChange={(e) => {

                        setKeyword(
                            e.target.value
                        );

                        setCurrentPage(1);
                    }}

                    className="post-search-input"
                />

            </div>





            {/* 헤더 */}
            <div className="post-table-header">

                <div>번호</div>

                <div>내용</div>

                <div>댓글</div>

                <div>관리</div>

            </div>





            {/* 게시글 */}
            <div className="post-table">

                {

                    posts.map((post) => (

                        <div

                            className="post-table-row"

                            key={post.id}
                        >

                            {/* 번호 */}
                            <div>

                                {post.id}

                            </div>





                            {/* 내용 */}
                            <div
                                className="post-content-cell"
                                dangerouslySetInnerHTML={{
                                    __html: post.content
                                }}
                            />





                            {/* 댓글 */}
                            <div className="post-comment-count">

                                {post.commentCount}개

                            </div>





                            {/* 관리 */}
                            <div className="post-action-cell">

                                <button

                                    className="action-button comment"

                                    onClick={() =>

                                        openComments(post)
                                    }
                                >

                                    댓글

                                </button>





                                <button

                                    className="action-button edit"

                                    onClick={() =>

                                        openEditModal(post)
                                    }
                                >

                                    수정

                                </button>





                                <button

                                    className="action-button delete"

                                    onClick={() =>

                                        handleDeletePost(
                                            post.id
                                        )
                                    }
                                >

                                    삭제

                                </button>

                            </div>

                        </div>
                    ))
                }

            </div>





            {/* 페이지네이션 */}
            <div className="pagination-wrap">

                <button

                    className="page-button"

                    onClick={() =>
                        setCurrentPage(1)
                    }
                >

                    {'<<'}

                </button>





                <button

                    className="page-button"

                    onClick={() => {

                        if(currentPage > 1) {

                            setCurrentPage(
                                currentPage - 1
                            );
                        }
                    }}
                >

                    {'<'}

                </button>





                {

                    pageNumbers.map((page) => (

                        <button

                            key={page}

                            className={

                                currentPage === page

                                    ? 'page-button active'

                                    : 'page-button'
                            }

                            onClick={() =>

                                setCurrentPage(page)
                            }
                        >

                            {page}

                        </button>
                    ))
                }





                <button

                    className="page-button"

                    onClick={() => {

                        if(currentPage < totalPages) {

                            setCurrentPage(
                                currentPage + 1
                            );
                        }
                    }}
                >

                    {'>'}

                </button>





                <button

                    className="page-button"

                    onClick={() =>

                        setCurrentPage(
                            totalPages
                        )
                    }
                >

                    {'>>'}

                </button>

            </div>





            {/* 수정 모달 */}
            {

                editOpen && (

                    <div className="edit-modal-overlay">

                        <div className="edit-modal">

                            <div className="edit-modal-title">

                                게시글 수정

                            </div>





                            <textarea

                                className="edit-textarea"

                                value={editContent}

                                onChange={(e) =>

                                    setEditContent(
                                        e.target.value
                                    )
                                }
                            />





                            <div className="edit-modal-buttons">

                                <button

                                    className="modal-button cancel"

                                    onClick={() =>

                                        setEditOpen(false)
                                    }
                                >

                                    취소

                                </button>





                                <button

                                    className="modal-button save"

                                    onClick={handleUpdatePost}
                                >

                                    저장

                                </button>

                            </div>

                        </div>

                    </div>
                )
            }

        </div>
    );
};

export default PostManage;